import { useContext, useEffect, useRef } from "react";
import QuizQuestion from "./QuizQuestion";
import QuizSkeleton from "./QuizSkeleton";

import { setScormPassed } from "sj-ui-toolkit/src/utils/rxd";

import { VideoContext } from "../../VideoContext";
import QuizReview from "./QuizReview";

import S from "./_styles.module.scss";

export default function QuizContent() {
  const { quiz } = useContext(VideoContext);
  const prevResultRef = useRef(quiz?.assessment.result);
  const isQuizComplete = quiz?.assessment.answersCount === quiz?.assessment.questionsCount;

  // Call setScormPassed when quiz result changes to "passed"
  useEffect(() => {
    const currentResult = quiz?.assessment.result;
    const previousResult = prevResultRef.current;

    if (previousResult === "in_progress" && currentResult === "passed") {
      setScormPassed({
        score: quiz?.assessment.assessmentScore ?? 0,
        max: 100,
        min: 0,
      });
    }

    prevResultRef.current = currentResult;
  }, [quiz?.assessment.result, quiz?.assessment.assessmentScore]);

  if (isQuizComplete) {
    return (
      <div className={S.quizContainer}>
        <QuizReview quiz={quiz} />
      </div>
    );
  }

  return (
    <div className={S.quizContainer}>
      {quiz?.question ? (
        <QuizQuestion
          answersCount={quiz.assessment.answersCount}
          questionsCount={quiz.assessment.questionsCount}
        />
      ) : (
        <QuizSkeleton />
      )}
    </div>
  );
}
